<template>
  <div
    class="tab-pane fade show active"
    id="nav-bills"
    role="tabpanel"
    aria-labelledby="nav-bills-tab"
  >
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-7">
          <div class="table-div mt-3">
            <b-table
              v-if="bills"
              id="bills"
              class="bills-table tbl-sml"
              striped
              :items="orderedBills"
              :fields="billFields"
              per-page="3"
            >
              <template slot="PeriodEnds" slot-scope="data">
                <div v-if="data.item.PeriodEnds">{{data.item.PeriodEnds | shortDate}}</div>
                <div v-else>{{data.item.Created | shortDate}}</div>
              </template>
              <template
                slot="NewCharges"
                slot-scope="data"
              >{{data.item.NewCharges.Amount | currency}}</template>
              <template slot="Status" slot-scope="row">
                <!-- This is the status such as draft, on hold or billed -->
                {{row.item.Status| splitString}}
                <i
                  v-if="row.item.Status == 'OnHold'"
                  @click="toggleRow(row)"
                  class="fas fa-info-circle pointer"
                ></i>
              </template>
              <template slot="row-details" slot-scope="row">
                <b-card>
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-4">
                          <p class="font-weight-bold">Reasons(s):</p>
                        </div>
                        <div class="col-8">
                          <div class="ta-group">
                            <b-textarea
                              v-model="row.item.StatusNarrative"
                              class="form-control bills-reason-fc z-depth-1"
                              rows="4"
                              :disabled="!editMode"
                              :maxlength="500"
                            ></b-textarea>
                            <div class="text-right small text-muted mt-1">
                              {{ (row.item.StatusNarrative || '').length }}/500
                            </div>
                            
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr class="mt-2" />
                  <div class="text-right mt-2" v-if="!editMode">
                    <b-btn
                      @click="toggleEditMode(true, row)"
                      class="btn btn-hc btn-sm"
                    >
                      Edit
                    </b-btn>
                  </div>
                  <div class="row" v-if="editMode">
                    <div class="col-12">
                      <div>
                        <div class="text-left float-right">
                          <b-btn
                            @click="toggleEditMode(false, row)"
                            class="btn btn-hc mr-1"
                            :disabled="submitStatus == 'PENDING'"
                          >Cancel</b-btn>
                          <b-btn
                            @click="saveChanges(row.item)"
                            class="btn btn-hc ml-1"
                            :disabled="submitStatus == 'PENDING'"
                          >
                            Save
                            Changes
                          </b-btn>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-card>
              </template>
              <template slot="SalesTransaction" slot-scope="data">
                <a style="cursor: pointer" @click="viewStatement(data.item.SalesTransaction.DocumentUri)">
                  <h5
                    class="font-weight-bold d-inline position-absolute"
                  >{{data.item.StatementNumber}}</h5>
                  <img src="@/assets/img/download_icon.png" class="d-inline" alt="Download a bill" />
                </a>
              </template>
              <template slot="Action" slot-scope="data">
                <!-- The action is dependant on the status -->
                <!-- If draft need to be able to commit, delete or hold. If on hold release and if billed you can cancel -->
                <div v-if="notCancelled.length != 0">
                  <div
                    v-if="data.item.StatementNumber == notCancelled[notCancelled.length - 1].StatementNumber"
                  >
                    <a
                      v-if="data.item.Status == 'Committed'"
                      href="#"
                      class="bb link"
                      data-toggle="modal"
                      data-target="#Cancel"
                      @click="rowClicked(data.item)"
                    >
                      Cancel
                      <br />
                    </a>
                  </div>
                </div>
                <a
                  v-if="showCommitOption(data.item)"
                  href="#"
                  class="bb link"
                  data-toggle="modal"
                  data-target="#Commit"
                  @click="rowClicked(data.item)"
                >
                  Commit
                  <br />
                </a>
                <a
                  v-if="showDeleteOption(data.item)"
                  href="#"
                  class="bb link"
                  data-toggle="modal"
                  data-target="#Delete"
                  @click="rowClicked(data.item)"
                >
                  Delete
                  <br />
                </a>
                <a
                  v-if="showHoldOption(data.item)"
                  href="#"
                  class="bb link"
                  data-toggle="modal"
                  data-target="#Hold"
                  @click="rowClicked(data.item)"
                >
                  Hold
                  <br />
                </a>
                <a
                  v-if="showReleaseOption(data.item)"
                  href="#"
                  class="bb link"
                  data-toggle="modal"
                  @click="release(data.item)"
                >
                  Release
                  <br />
                </a>
              </template>
            </b-table>
          </div>
          <div class="row">
            <div class="col-sm-12 mt-4">
              <div class="col-sm-12 col-md-6 d-inline mb-2">
                <a
                  class="btn btn-hc btn-xs-block btn-sm-block float-left mb-2"
                  role="button"
                  data-toggle="modal"
                  data-target="#viewAllBills"
                >View All Bills</a>
              </div>
              <div class="col-sm-12 col-md-6 d-inline mb-2">
                <a
                  class="btn btn-hc btn-xs-block btn-sm-block float-right"
                  role="button"
                  data-toggle="modal"
                  data-target="#createBillRun"
                >New Bill</a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-5 mt-3 mt-md-0">
          <chartjs-doughnut
            v-if="agedDebt && agedDebt.Balance > 0 && agedDebt.Balance - bands[0] > 0"
            :width="100"
            :height="100"
            :labels="labels"
            :data="bands"
            :backgroundcolor="colours"
            :hoverbackgroundcolor="colours"
            :hoverbordercolor="borderColours"
            :option="option"
          ></chartjs-doughnut>
          <!-- If chart isn't working, check version number in package.json - should be 1.2.8 -->
          <div v-else class="h-100">
            <div class="d-flex h-100 justify-content-center align-items-center">
              <img
                src="@/assets/img/tick_selector.png"
                class="img-fluid d-inline-block"
                alt="No debt greater than 30 days"
              />
              <p class="d-inline-block my-auto pl-2">No debt older than {{labels[0]}}.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import billOptions from "@/mixins/billOptions.js";

export default {
  mixins: [billOptions],
  data() {
    return {
      billFields: {
        PeriodEnds: {
          label: "End Date",
          sortable: true,
          class: "text-center col-2",
        },
        NewCharges: {
          label: "Total Value",
          class: "text-center col-2",
        },
        Status: {
          label: "Status",
          class: "text-center col-3",
        },
        SalesTransaction: {
          label: "View",
          class: "text-center col-2",
        },
        Action: {
          label: "Action",
          class: "text-center col-3",
        },
      },
      option: {
        responsive: true,
        maintainAspectRatio: true,
        onResize: null,
        title: {
          display: true,
          position: "top",
          text: "Aged Debt",
        },
      },
    };
  },
  computed: {
    details() {
      return this.$store.state.finances.billDetails;
    },
    agedDebt() {
      return this.$store.state.finances.agedDebt;
    },
    bands() {
      return this.$config.honeycomb.agedDebt.bands.map((b) => this.agedDebt[b]);
    },
    labels() {
      return this.$config.honeycomb.agedDebt.labels; //.map(b => b + ' days')
    },
    colours() {
      return this.$config.honeycomb.agedDebt.colours;
    },
    borderColours() {
      return this.$config.honeycomb.agedDebt.borderColours;
    },
  },
  methods: {
    saveChanges(statement) {
      this.submitStatus = "PENDING";
      this.$http
        .put(
          "https://" +
            this.$config.honeycomb.billbot.domain +
            "/api/v1/OnHold/set",
          {
            StatementId: statement.Id,
            StatusNarrative: statement.StatusNarrative,
          },
          {
            withCredentials: true,
          }
        )
        .then(() => {
          this.submitStatus = "OK";
          this.editMode = false;
          this.$snotify.success(`Success! On hold reason(s) updated.`);
        })
        .catch((error) => {
          // Error
          this.submitStatus = "ERROR";
          Object.assign(statement, this.beforeEditingNarrative);
          this.editMode = false;
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            if (error.response.data.MoreInformation.length > 0) {
              error.response.data.MoreInformation.forEach((e) => {
                this.$snotify.error(`${e.Error}`, {
                  timeout: 0,
                  closeOnClick: true,
                });
              });
            } else {
              this.$snotify.error(`${error.response.data.UserDescription}`, {
                timeout: 0,
                closeOnClick: true,
              });
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            this.$snotify.error(`No response recieved.`, {
              timeout: 0,
              closeOnClick: true,
            });
          } else {
            // Something happened in setting up the request that triggered an Error
            this.$snotify.error(`${error.message}`, {
              timeout: 0,
              closeOnClick: true,
            });
          }
        });
    },
    release(item) {
      this.$http
        .put(
          "https://" +
            this.$config.honeycomb.billbot.domain +
            "/api/v1/OnHold/release/" +
            item.Id,
          {
            BillIds: [item.Id],
          },
          {
            withCredentials: true,
          }
        )
        .then(() => {
          this.submitStatus = "OK";
          this.$snotify.success(`Success! Bill released.`);
          this.$store.dispatch("getBills");
          this.$store.dispatch("getLedger");
          this.$store.dispatch("getCharges");
          this.$store.dispatch("getUsage");
          this.$store.dispatch("refreshReadings");

          setTimeout(() => {
            this.$store.dispatch("refreshCustomer");
          }, 3000);
        })
        .catch((error) => {
          // Error
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            this.submitStatus = "Error";
            if (error.response.data.MoreInformation.length > 0) {
              error.response.data.MoreInformation.forEach((e) => {
                this.$snotify.error(`${e.Error}`, {
                  timeout: 0,
                  closeOnClick: true,
                });
              });
            } else {
              this.$snotify.error(`${error.response.data.UserDescription}`, {
                timeout: 0,
                closeOnClick: true,
              });
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            this.submitStatus = "Error";
            this.$snotify.error(`No response recieved.`, {
              timeout: 0,
              closeOnClick: true,
            });
          } else {
            // Something happened in setting up the request that triggered an Error
            this.submitStatus = "Error";
            this.$snotify.error(`${error.message}`, {
              timeout: 0,
              closeOnClick: true,
            });
          }
        });
    },

    viewStatement(documentUri) {
      // Extract the statement ID from the DocumentUri on the SalesTransaction
      const urlParts = documentUri.split('/');
      const statementId = urlParts[urlParts.length - 2]; // Get the part before '/uri'

      this.$http
          .get(
              "https://" +
              this.$config.honeycomb.billbotstatements.domain +
              "/api/v1/statements/" +
              statementId +
              "/uri",
              {
                withCredentials: true
              }
          )
          .then((response) => {
                const finalUrl = response.data.url;
                window.open(finalUrl, "_blank");
              }
          )
          .catch((error) => {
            if (error.response) {
              this.$snotify.error(
                  `Error viewing statement: ${(error.response.data && error.response.data.UserDescription) || error.response.statusText}`,
                  {
                    timeout: 0,
                    closeOnClick: true,
                  }
              );
            } else if (error.request) {
              this.$snotify.error(`No response received.`, {
                timeout: 0,
                closeOnClick: true,
              });
            } else {
              this.$snotify.error(`${error.message}`, {
                timeout: 0,
                closeOnClick: true,
              });
            }
          });
    },
  },
};
</script>
